import { containsQuery, OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, downloadFileHandler, request } from "services/request";

const resource = "api/counterpartyGroups";
const groupsQuery = { orderBy: "id desc" };

const list = (params: {}) => request(`${resource}/getNamesList${containsQuery(params)}`, { method: "GET" });

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter }, ...groupsQuery });
    return request(`${resource}/getlist${query}`, { method: "GET" }, { countInHeaders: true });
};

const getListExcel = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter, ...groupsQuery });
    return request(`${resource}/getListExcel?${query}`, { method: "GET" }, { withoutMiddleware: true }).then((res) =>
        downloadFileHandler(res, "Группы контрагентов.xlsx"),
    );
};

const apply = (params: {}) => alertRequest(`${resource}/apply`, body(params));

const clear = (params: {}) => alertRequest(`${resource}/clear`, body(params));

const addCounterpartiesWithoutGroup = (params: {}) =>
    alertRequest(`${resource}/addCounterpartiesWithoutGroup`, body(params));

const setGroupForCounterparties = (params: {}) => alertRequest(`${resource}/setGroupForCounterparties`, body(params));

const getItem = ({ id }: { id: number }) => request(`${resource}/get/${id}`, { method: "GET" });

const delItem = (params: {}) => alertRequest(`${resource}/delete`, body(params));

export {
    list,
    apply,
    index,
    getItem,
    delItem,
    clear,
    addCounterpartiesWithoutGroup,
    setGroupForCounterparties,
    getListExcel,
};
